<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
    <client-only>
        <div v-if="isVisible"
            class="flex flex-col overflow-hidden rounded"
            :style="variables"
            :class="{
                // background
                'bg-[color:var(--main-background)]': isCustomMainBackgroundColor,
                'bg-white': mainTheme?.background?.color === 'WHITE',
                'bg-black': mainTheme?.background?.color === 'BLACK',
                'bg-yellow-500': mainTheme?.background?.color === 'YELLOW',
                'bg-[#EF1C35]': !mainTheme || mainTheme.background?.color === 'RED',
                // text
                'text-[color:var(--main-text)]': isCustomMainTextColor,
                'text-black': mainTheme?.text?.color === 'BLACK',
                'text-yellow-500': mainTheme?.text?.color === 'YELLOW',
                'text-[#EF1C35]': mainTheme?.text?.color === 'RED',
                'text-white': !mainTheme || mainTheme.text?.color === 'WHITE',
            }">
            <div class="flex flex-col items-center justify-center px-2.5 text-center
                font-prenton-cond uppercase tracking-2xl"
                :class="{
                    'order-1': isStyleMirrored,
                }">
                <p v-if="promotion.style?.type === PromotionStyleType.Text"
                    class="py-1 leading-none md:leading-none"
                    :style="variables"
                    :class="{
                        'font-prenton-cond': mainTheme?.font?.family === 'PRENTON_COND',
                        'font-sans-narrow': mainTheme?.font?.family === 'SANS_NARROW',
                        'font-sans-caption': mainTheme?.font?.family === 'SANS_CAPTION',
                        // size
                        'text-xs': mainTheme?.font?.size === 'EXTRA_SMALL',
                        'text-sm': mainTheme?.font?.size === 'SMALL',
                        'text-base': mainTheme?.font?.size === 'MEDIUM',
                        'text-lg': mainTheme?.font?.size === 'LARGE',
                        'text-xl': mainTheme?.font?.size === 'EXTRA_LARGE',
                        'text-[length:var(--main-font-size)]': mainTheme?.font.size === 'CUSTOM',
                    }">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <span v-html="promotion.style.content?.split('|').join('<br>')"></span>
                </p>

                <p
                    v-else-if="
                        promotion.style?.type === PromotionStyleType.Percent
                            || promotion.style?.type === PromotionStyleType.PercentWithAmount
                            || promotion.style?.type === PromotionStyleType.PercentWithText
                            || promotion.style?.type === PromotionStyleType.ClubPercentWithText
                    "
                    :class="{
                        'font-prenton-cond': mainTheme?.font?.family === 'PRENTON_COND',
                        'font-sans-narrow': mainTheme?.font?.family === 'SANS_NARROW',
                        'font-sans-caption': mainTheme?.font?.family === 'SANS_CAPTION',
                        // size
                        'text-xs': mainTheme?.font?.size === 'EXTRA_SMALL',
                        'text-sm': mainTheme?.font?.size === 'SMALL',
                        'text-base': mainTheme?.font?.size === 'MEDIUM',
                        'text-lg': mainTheme?.font?.size === 'LARGE',
                        'text-xl': mainTheme?.font?.size === 'EXTRA_LARGE',
                        'text-[length:var(--main-font-size)]': mainTheme?.font.size === 'CUSTOM',
                    }">
                    <span v-if="promotion.__typename === 'CatalogPromotionFixedAmount'">
                        -{{ formatCurrency(discountAmount ?? '') }}
                    </span>

                    <span v-else>
                        -{{ discountAmount ?? '' }}%
                    </span>
                </p>
            </div>

            <p v-if="promotion.style?.type === PromotionStyleType.PercentWithAmount && savedAmount > 0"
                class="hidden px-2 text-center font-sans font-bold md:block"
                :class="{
                    // background
                    'bg-[color:var(--main-background)]': isCustomAltTextColor,
                    'bg-white': altTheme?.background?.color === 'WHITE',
                    'bg-black': altTheme?.background?.color === 'BLACK',
                    'bg-yellow-500': altTheme?.background?.color === 'YELLOW',
                    'bg-orange-500': altTheme?.background?.color === 'ORANGE',
                    'bg-[#EF1C35]': !altTheme || altTheme.background?.color === 'RED',
                    // text
                    'text-[color:var(--alt-text)]': isCustomAltTextColor,
                    'text-black': altTheme?.text?.color === 'BLACK',
                    'text-yellow-500': altTheme?.text?.color === 'YELLOW',
                    'text-orange-500': altTheme?.text?.color === 'ORANGE',
                    'text-[#EF1C35]': altTheme?.text?.color === 'RED',
                    'text-white': !altTheme || altTheme.text?.color === 'WHITE',
                    //font
                    'font-prenton-cond': altTheme?.font?.family === 'PRENTON_COND',
                    'font-sans-narrow': altTheme?.font?.family === 'SANS_NARROW',
                    'font-sans-caption': altTheme?.font?.family === 'SANS_CAPTION',
                    // size
                    'text-xs md:text-sm lg:text-xs': altTheme?.font?.size === 'EXTRA_SMALL',
                    'text-xs md:text-sm lg:text-sm': altTheme?.font?.size === 'SMALL',
                    'text-xs md:text-sm lg:text-base': altTheme?.font?.size === 'MEDIUM',
                    'text-xs md:text-sm lg:text-lg': altTheme?.font?.size === 'LARGE',
                    'text-xs md:text-sm lg:text-xl': altTheme?.font?.size === 'EXTRA_LARGE',
                    'text-[length:var(--alt-font-size)]': altTheme?.font.size === 'CUSTOM',
                }">
                <span>{{ $t('discount.save', { amount: formatCurrency(savedAmount) }) }}</span>
            </p>

            <p v-else-if="promotion.style?.type === PromotionStyleType.PercentWithText
                   || promotion.style?.type === PromotionStyleType.ClubPercentWithText"
                class="px-2 text-center font-sans font-bold"
                :class="{
                    // background
                    'bg-[color:var(--alt-background)]': isCustomAltBackgroundColor,
                    'bg-white': altTheme?.background?.color === 'WHITE',
                    'bg-black': altTheme?.background?.color === 'BLACK',
                    'bg-yellow-500': altTheme?.background?.color === 'YELLOW',
                    'bg-orange-500': altTheme?.background?.color === 'ORANGE',
                    'bg-[#EF1C35]': !altTheme || altTheme.background?.color === 'RED',
                    // text
                    'text-[color:var(--alt-text)]': isCustomAltTextColor,
                    'text-black': altTheme?.text?.color === 'BLACK',
                    'text-yellow-500': altTheme?.text?.color === 'YELLOW',
                    'text-orange-500': altTheme?.text?.color === 'ORANGE',
                    'text-[#EF1C35]': altTheme?.text?.color === 'RED',
                    'text-white': !altTheme || altTheme.text?.color === 'WHITE',
                    //font
                    'font-prenton-cond': altTheme?.font?.family === 'PRENTON_COND',
                    'font-sans-narrow': altTheme?.font?.family === 'SANS_NARROW',
                    'font-sans-caption': altTheme?.font?.family === 'SANS_CAPTION',
                    // size
                    'text-xs lg:text-xs': altTheme?.font?.size === 'EXTRA_SMALL',
                    'text-xs lg:text-sm': altTheme?.font?.size === 'SMALL',
                    'text-xs lg:text-base': altTheme?.font?.size === 'MEDIUM',
                    'text-xs lg:text-lg': altTheme?.font?.size === 'LARGE',
                    'text-xs lg:text-xl': altTheme?.font?.size === 'EXTRA_LARGE',
                    'text-[length:var(--alt-font-size)]': altTheme?.font.size === 'CUSTOM',
                }">
                {{ promotion.style.altContent }}
            </p>
        </div>
    </client-only>
</template>

<script setup lang="ts">
import { PromotionStyleType, type ViewProductDetailsQuery } from '~/graphql';

// NOTE: Also see the other sale-tag component we have!

type DetailProduct = Extract<
    ViewProductDetailsQuery['product'],
    { __typename: 'SimpleProduct' }
>;

type Promotion = DetailProduct['promotions'][0];

const properties = defineProps<{
    promotion: Promotion
    price?: string
    originalPrice?: string
    promotionPrice?: string
    clubPrice?: number
}>();

const { format: formatCurrency } = useCurrency();

// Compute the *real* discount amount, computed from the product's original price (ie its omnibus price) vs its current price. This may differ from whatever values the promotion sets, since those are applied against the product base sales price rather than its omnibus price. Also see the elevate connector.
const discountAmount = computed(() => {
    if (properties.price === undefined && properties.clubPrice === undefined) {
        return undefined;
    }

    const discountedPrice = properties.clubPrice ?? Number.parseFloat(properties.price as string);
    const originalPrice = properties.originalPrice === undefined
        ? discountedPrice
        : Number.parseFloat(properties.originalPrice);

    const type = properties.promotion.__typename;

    if (type === 'CatalogPromotionFixedAmount') {
        const amount = originalPrice - discountedPrice;
        return amount > 0 ? amount : undefined;
    }

    if (type === 'CatalogPromotionPercent' || type === 'CatalogPromotionProductPromotionPrice') {
        const percent = (1 - (discountedPrice / originalPrice)) * 100;
        return percent > 0 ? Math.round(percent) : undefined;
    }

    return undefined;
});

const savedAmount = computed(() => (
    properties.originalPrice && properties.price
        ? Number.parseFloat(properties.originalPrice) - Number.parseFloat(properties.price)
        : 0
));

const isVisible = computed(() => (
    (properties.promotion.style?.type !== 'TEXT'
        && discountAmount.value !== undefined
        && discountAmount.value > 0)
    || (
        properties.promotion.style?.type === 'TEXT'
        && properties.promotion.style?.content !== null
    )
    || (
        properties.promotion.style?.type === 'CLUB_PERCENT_WITH_TEXT'
        && properties.clubPrice !== undefined
        && Number(properties.clubPrice) > 0
    )
));

const mainTheme = computed(() => properties.promotion.style?.mainTheme);
const altTheme = computed(() => properties.promotion.style?.altTheme);

const isStyleMirrored = computed(() => properties.promotion.style?.mirrored);

// Custom Main
const isCustomMainBackgroundColor = computed(() => mainTheme.value?.background?.color === 'CUSTOM');
const isCustomMainTextColor = computed(() => mainTheme.value?.text?.color === 'CUSTOM');
const mainFontSize = computed(() => mainTheme.value?.font?.size);
const mainFontFamily = computed(() => mainTheme.value?.font?.family);
const isCustomMainFontSize = computed(() => mainTheme.value?.font?.size === 'CUSTOM');

// Custom Alt
const isCustomAltBackgroundColor = computed(() => altTheme.value?.background?.color === 'CUSTOM');
const isCustomAltTextColor = computed(() => altTheme.value?.text?.color === 'CUSTOM');
const isCustomAltFontSize = computed(() => altTheme.value?.font?.size === 'CUSTOM');

const fontFamily = ref('');

const variables = computed(() => ({
    /* eslint-disable @typescript-eslint/naming-convention */
    ...isCustomMainBackgroundColor ? {
        '--main-background': mainTheme.value?.background?.customColor ?? undefined,
    } : {},
    ...isCustomMainTextColor ? {
        '--main-text': mainTheme.value?.text?.customColor ?? undefined,
    } : {},
    ...isCustomAltBackgroundColor ? {
        '--alt-background': altTheme.value?.background?.customColor ?? undefined,
    } : {},
    ...isCustomAltTextColor ? {
        '--alt-text': altTheme.value?.text?.customColor ?? undefined,
    } : {},
    ...mainFontFamily ? {
        '--font-family': fontFamily.value ?? undefined,
    } : {},
    ...mainFontSize ? {
        '--font-size': mainTheme.value?.font?.size ? `${mainTheme.value?.font?.size}` : undefined,
    } : {},
    ...isCustomMainFontSize ? {
        '--main-font-size': mainTheme.value?.font?.customSize ? `${mainTheme.value?.font?.customSize}px` : undefined,
    } : {},
    ...isCustomAltFontSize ? {
        '--alt-font-size': altTheme.value?.font?.customSize ? `${altTheme.value?.font?.customSize}px` : undefined,
    } : {},
    /* eslint-enable @typescript-eslint/naming-convention */
}));
</script>
